export default __webpack_public_path__ + "a11687a91396bd9968779c1e4706d0e6.svg";